/**
 * MUI theme factory for saas-admin. Hard-coded Journix-platform palette;
 * if the platform tenant ever becomes its own Brand entity, this would
 * accept the BrandDto and derive colors/fonts from it.
 */
import { createTheme, type Theme } from '@mui/material/styles';

export function createAppTheme(): Theme {
  return createTheme({
    palette: {
      mode: 'light',
      primary: { main: '#1d4ed8' },
      secondary: { main: '#0f766e' },
      success: { main: '#15803d' },
      warning: { main: '#b45309' },
      error: { main: '#b91c1c' },
      info: { main: '#0369a1' },
      background: { default: '#f7f8fa', paper: '#ffffff' },
    },
    typography: {
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
      h1: { fontSize: '1.75rem', fontWeight: 600 },
      h2: { fontSize: '1.25rem', fontWeight: 600 },
      h3: { fontSize: '1.05rem', fontWeight: 600 },
    },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { textTransform: 'none', fontWeight: 500 },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { fontWeight: 500 },
        },
      },
    },
  });
}
